import Page from '@/components/pages/app-settings/live/page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/app-settings/live')({
  component: Page,
})

